export enum AccountPageTabsEnum {
  PARTNER = 'Partner',
  JETTONS = 'Jettons',
  GAMES_HISTORY = 'Games',
  JACKPOTS_HISTORY = 'Jackpots',
  KYC = 'KYC',
}
